import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { supportChatApi as api } from '../../services/supportChatApi';
import useChatPolling from './useChatPolling';
import { moduleNames } from './observationProtocol';

export default function UsageMetrics({ conversationId }) {
  const { t } = useTranslation('supportChat');
  const duration = seconds => t('usageMetrics.durationMinutes', { count: Math.round((seconds || 0) / 60) });
  const [open, setOpen] = useState(false);
  const [days, setDays] = useState(7);
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  return <details className="eo-usage-metrics" onToggle={event => setOpen(event.currentTarget.open)}>
    <summary>{conversationId ? t('usageMetrics.titleUser') : t('usageMetrics.titleApp')}</summary>
    {open && <div className="eo-usage-content"><label>{t('usageMetrics.periodLabel')} <select aria-label={t('usageMetrics.periodAria')} value={days} onChange={event => { setDays(Number(event.target.value)); setData(null); }}><option value={7}>{t('usageMetrics.last7Days')}</option><option value={30}>{t('usageMetrics.last30Days')}</option></select></label>
      <MetricsLoader key={`${conversationId || 'all'}:${days}`} days={days} conversationId={conversationId} update={setData} fail={setError} />
      {error && <p role="alert">{error}</p>}
      {!data && !error && <p>{t('usageMetrics.loadingMetrics')}</p>}
      {data && <><div className="eo-usage-kpis">
        <div><strong>{data.users}</strong><span>{t('usageMetrics.activeUsers')}</span></div><div><strong>{data.sessions}</strong><span>{t('usageMetrics.sessions')}</span></div>
        <div><strong>{data.views}</strong><span>{t('usageMetrics.screensAccessed')}</span></div><div><strong>{duration(data.activeSeconds)}</strong><span>{t('usageMetrics.estimatedActiveTime')}</span></div>
      </div>
        <table><thead><tr><th>{t('usageMetrics.moduleHeader')}</th><th>{t('usageMetrics.accessesHeader')}</th><th>{t('usageMetrics.activeTimeHeader')}</th></tr></thead><tbody>{data.modules.map(row => <tr key={row._id}><td>{t(`moduleNames.${row._id}`, moduleNames[row._id] || t('usageMetrics.otherModule'))}</td><td>{row.views}</td><td>{duration(row.activeSeconds)}</td></tr>)}</tbody></table>
        {!data.modules.length && <p>{t('usageMetrics.noDataYet')}</p>}
      </>}
      <small>{t('usageMetrics.retentionNote')}</small>
    </div>}
  </details>;
}
function MetricsLoader({ days, conversationId, update, fail }) {
  const { t } = useTranslation('supportChat');
  useChatPolling(async signal => {
    try {
      const path = conversationId ? `/conversations/${conversationId}/usage` : '/usage/summary';
      const { data } = await api.get(`/api/v1/support-chat${path}`, { params: { days }, signal });
      if (!signal.aborted) { update(data); fail(''); }
    } catch (err) { if (!signal.aborted) fail(t('usageMetrics.loadError')); }
  }, 30000);
  return null;
}
